module.exports = __webpack_public_path__ + "img/feedback4.0521d658.png";